import { PersonalzugangField } from '@/domain/mitarbeiter/features/anlageassistent/components/MitarbeiterSpeicheroptionen/Fields/PersonalzugangField';
import { useTranslation } from 'react-i18next';

export function MitarbeiterSpeicheroptionenContent() {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col gap-4">
      <span className="text-neutrals-900 text-base font-bold leading-6">
        {t(
          'domain.mitarbeiter.create.speicheroptionen.dialog.app_fragebogen.title',
        )}
      </span>
      <PersonalzugangField />
    </div>
  );
}
